export default "__VITE_ASSET__ELtk7MlG__"